import BaseApi from './base'

class LogSwitchTo extends BaseApi {
  getLogSwitchTo = (query) => this.client.get(`/switch-to/logs?${query}`)
}

export default new LogSwitchTo()
